export default {"src":"/_next/static/media/supercell-id-white.fe9b60a2.svg","height":29,"width":32};